import { USER_COLLAPSE, USER_EXPAND } from 'common/actions/row-groups/types';

export const CAP_TABLE_ROW_GROUPS_LEGACY_BUCKET = 'legacy';

export type CapTableRowGroupsByCapTable = Record<string, Record<string, string>>;

const isRowPreferenceValue = (value: unknown): value is string =>
  value === USER_EXPAND || value === USER_COLLAPSE;

export const isFlatCapTableRowGroupPrefs = (
  prefs: Record<string, unknown> | null | undefined
): boolean => {
  if (!prefs || typeof prefs !== 'object') return false;
  return Object.values(prefs).some(isRowPreferenceValue);
};

export const getCapTableRowPrefsBucket = (
  allPrefs: CapTableRowGroupsByCapTable | Record<string, string> | null | undefined,
  capTableId?: number
): Record<string, string> => {
  if (!allPrefs || typeof allPrefs !== 'object') {
    return {};
  }

  if (isFlatCapTableRowGroupPrefs(allPrefs as Record<string, unknown>)) {
    return allPrefs as Record<string, string>;
  }

  const nested = allPrefs as CapTableRowGroupsByCapTable;
  if (capTableId !== undefined) {
    const bucket = nested[String(capTableId)];
    if (bucket && typeof bucket === 'object') {
      return bucket;
    }
  }

  const legacy = nested[CAP_TABLE_ROW_GROUPS_LEGACY_BUCKET];
  if (legacy && typeof legacy === 'object') {
    return legacy;
  }

  return {};
};

export const normalizeCapTableRowGroupsStorage = (
  allPrefs: unknown,
  capTableId?: number
): CapTableRowGroupsByCapTable => {
  if (!allPrefs || typeof allPrefs !== 'object') {
    return {};
  }

  const record = allPrefs as Record<string, unknown>;

  if (isFlatCapTableRowGroupPrefs(record)) {
    if (capTableId !== undefined) {
      return { [String(capTableId)]: record as Record<string, string> };
    }
    return { [CAP_TABLE_ROW_GROUPS_LEGACY_BUCKET]: record as Record<string, string> };
  }

  return record as CapTableRowGroupsByCapTable;
};

export const mergeCapTableRowPrefsForSave = (
  allPrefs: CapTableRowGroupsByCapTable | Record<string, string> | null | undefined,
  capTableId: number | undefined,
  bucketUpdate: Record<string, string>
): CapTableRowGroupsByCapTable => {
  const normalized = normalizeCapTableRowGroupsStorage(allPrefs, capTableId);

  if (capTableId === undefined) {
    return {
      ...normalized,
      [CAP_TABLE_ROW_GROUPS_LEGACY_BUCKET]: {
        ...(normalized[CAP_TABLE_ROW_GROUPS_LEGACY_BUCKET] ?? {}),
        ...bucketUpdate,
      },
    };
  }

  return {
    ...normalized,
    [String(capTableId)]: {
      ...(normalized[String(capTableId)] ?? {}),
      ...bucketUpdate,
    },
  };
};
